import { Link } from "react-router-dom"
import { HelpCircle, Bell, User } from "lucide-react"
import { Button } from "@/components/ui/button"
import { NAVIGATION_ROUTES } from '@/constants/routes'

interface HeaderProps {
  isLoggedIn?: boolean
  onLoginClick?: () => void
}

export function Header({ isLoggedIn = false, onLoginClick }: HeaderProps) {
  return (
    <header className="container mx-auto px-4 py-4 flex items-center justify-between mt-4">
      <Link to={NAVIGATION_ROUTES.HOME} className="flex items-center gap-2">
        <div className="flex items-center gap-2 text-xl font-bold">
          <div className="w-8 h-8 bg-black rounded-lg flex items-center justify-center">
            <div className="w-4 h-4 border-2 border-white rounded-full" />
          </div>
          <span className="text-gray-900">Easy Share</span>
        </div>
        {/* <span className="text-sm text-gray-600">模板</span> */}
        {/* <ChevronDown className="w-4 h-4 text-gray-600" /> */}
      </Link>

      <nav className="flex items-center gap-3 bg-white/80 backdrop-blur-sm rounded-2xl px-2 py-2 shadow-sm">
        {isLoggedIn ? (
          <>
            <Link to={NAVIGATION_ROUTES.HISTORY}>
              <Button 
                variant="ghost" 
                size="sm" 
                className="text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg px-3 py-2 h-9 text-sm font-medium"
              >
                传输历史
              </Button>
            </Link>
            <Link to={NAVIGATION_ROUTES.CLOUD}>
              <Button 
                variant="ghost" 
                size="sm" 
                className="text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg px-3 py-2 h-9 text-sm font-medium"
              >
                我的云盘
              </Button>
            </Link>

            <div className="w-px h-6 bg-gray-200" />

            {/* <Button 
              variant="ghost" 
              size="icon" 
              className="text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg w-9 h-9"
            >
              <ShoppingBag className="w-5 h-5" />
            </Button> */}
            <Button 
              variant="ghost" 
              size="icon" 
              className="text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg w-9 h-9"
            >
              <HelpCircle className="w-5 h-5" />
            </Button>
            <Button 
              variant="ghost" 
              size="icon" 
              className="text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg w-9 h-9 relative"
            >
              <Bell className="w-5 h-5" />
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full" />
            </Button>

            <Link to={NAVIGATION_ROUTES.SETTINGS}>
              <Button 
                variant="ghost" 
                size="icon" 
                className="text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg w-9 h-9"
              >
                <User className="w-5 h-5" />
              </Button>
            </Link>
          </>
        ) : (
          <>
            <Button 
              variant="ghost" 
              size="icon" 
              className="text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg w-9 h-9"
            >
              <HelpCircle className="w-5 h-5" />
            </Button>
            {/* <Button 
              variant="ghost" 
              size="sm" 
              className="text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg px-3 py-2 h-9 text-sm font-medium"
            >
              定价
            </Button> */}
            <Button 
              variant="ghost" 
              size="sm" 
              className="text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg px-3 py-2 h-9 text-sm font-medium" 
              onClick={onLoginClick}
            >
              注册/登录
            </Button>
          </>
        )}
      </nav>
    </header>
  )
}
